<script>
import { CreateCampaign } from "@/graphql/mutations";
import { getAccountId } from "@/lib/auth";

export default {
  name: "CreateCampaignLogic",
  props: {
    baseTemplateCategoryId: {
      type: String,
      default: "",
    },
    baseTemplateId: {
      type: String,
      default: "",
    },
    campaignId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      creatingCampaign: false,
      errors: [],
    };
  },
  methods: {
    createCampaign() {
      this.errors = [];
      this.creatingCampaign = true;

      const input = {};
      // If we're selecting a template add the baseTemplateId...
      if (this.baseTemplateId) input.baseTemplateId = this.baseTemplateId;
      // If we're duplicating a campaign pass through the campaignId...
      if (this.campaignId) input.campaignId = this.campaignId;

      // Call to the graphql mutation
      this.$apollo
        .mutate({
          // Query
          mutation: CreateCampaign,
          // Parameters
          variables: { input },
        })
        .then((res) => {
          // Result
          const { campaignId } = res.data.createCampaign;

          // Navigate to /campaign:id
          this.$router.push({
            name: "Campaign",
            params: { id: campaignId },
          });

          this.creatingCampaign = false;

          // Track the events...
          this.sendTrackingEvents();
        })
        .catch((error) => {
          this.creatingCampaign = false;
          this.errors.push(error);
          this.$modal.show("error", {
            errors: this.errors,
          });
        });
    },
    sendTrackingEvents() {
      this.$gtm.trackEvent({
        event: "promo-create-campaign",
        accountId: getAccountId(),
      });

      if (this.baseTemplateId) {
        this.$gtm.trackEvent({
          event: "basetemplate-selected",
          accountId: getAccountId(),
          baseTemplateId: this.baseTemplateId,
        });
      }

      if (this.baseTemplateCategoryId) {
        this.$gtm.trackEvent({
          event: "category-selected",
          accountId: getAccountId(),
          categoryId: this.baseTemplateCategoryId,
        });
      }
    },
  },
  render() {
    return this.$scopedSlots.default({
      createCampaign: this.createCampaign,
      creatingCampaign: this.creatingCampaign,
    });
  },
};
</script>
